<template>
	<b-modal
		ref="updateDescriptionModal"
		size="md"
		hide-footer
		@hidden="handleCloseModal"
		no-close-on-backdrop
		no-close-on-esc
	>
		<template #modal-header>
			<div class="d-flex justify-content-between align-items-center w-100">
				<div class="font-weight-bold">Actualizar Descripción</div>
				<div class="d-flex gap-x-2">
					<div style="display: flex; gap: 0.5rem">
						<b-button
							variant="success"
							@click="updateDescription"
							v-b-tooltip.hover="'Actualizar'"
							:disabled="!description"
						>
							<FeatherIcon icon="SaveIcon" />
						</b-button>
					</div>
					<div style="display: flex; gap: 0.5rem">
						<b-button variant="danger" @click="handleCloseModal" v-b-tooltip.hover="'Cerrar'">
							<FeatherIcon icon="XIcon" />
						</b-button>
					</div>
				</div>
			</div>
		</template>
		<b-row>
			<b-col>
				<b-form-group label="Descripción" label-for="description">
					<b-form-textarea v-model="description" placeholder="Ingrese la descripción"></b-form-textarea>
				</b-form-group>
			</b-col>
		</b-row>
	</b-modal>
</template>

<script>
import TournamentKnivesService from "@/views/brain/tournament/views/knives/services/tournament-knives.service.js"

export default {
	name: "UpdateDescriptionModal",
	props: {
		knife: Object,
	},
	components: {},
	data: () => ({
		description: "",
	}),
	computed: {},
	methods: {
		handleCloseModal() {
			this.$emit("close")
		},
		async updateDescription() {
			try {
				await TournamentKnivesService.updateDescription(this.knife.id, {
					description: this.description,
				})
				this.showSuccessToast("Descripción actualizada exitosamente")
				this.$emit("refresh")
				this.handleCloseModal()
			} catch (error) {
				console.error("Error updating knife:", error)
			}
		},
	},

	mounted() {
		this.description = this.knife.description
		this.$refs["updateDescriptionModal"].toggle()
	},
}
</script>
<style lang="scss" scoped></style>
